import React, { useState, useEffect } from "react";
// import "../Styles/globals.css";
import { toAbsoluteUrl } from "../../../toAbsoluteUrl";
import { callApi } from "../../../API";
import { resendInvite, removeFromCompany } from "../../../allFunctions";
import Pagination from "../../../Components/pagination";
import { useNavigate } from "react-router-dom";
import BreadcrumbsComponent from "../../../Components/Breadcrumbs.jsx";

export default function OrdersAndReservations() {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(0);
  const [data, setData] = useState([]);
  const [firstLoadNoData, setFirstLoadNoData] = useState(false);
  const [breadCrump, setBreadCrump] = useState([
    { name: "Home", link: "/" },
    { name: "My Team", link: "businessDashboard/myteam" },
  ]);
  const bodyData = [
    {
      transactionId: 1234,
      amount: "455AED",
      date: "12/07/2024 - 12:30PM",
      paymentMethod: "Wallet",
      category: "Reservation",
      taxInvoice: "download",
      topUp: 0,
      orderID: "1230",
    },
    {
      transactionId: 123,
      amount: "305AED",
      date: "12/07/2024 - 12:30PM",
      paymentMethod: "Bank Transfer",
      category: "Order",
      taxInvoice: "download",
      topUp: 1,
      orderID: "1210",
    },
  ];

  function displayBody() {
    let studentsList = "";
    studentsList = bodyData.map((rowData, index) => {
      return (
        <tr key={index}>
          <td className="col-lg-1 col-6 order-1">
            <span className="d-block d-lg-none">Order ID </span>{" "}
            {rowData.orderID == "" ? "-" : rowData.orderID}
          </td>
          <td className="col-lg-1 col-6 order-1">
            <span className="d-block d-lg-none">Transaction ID </span>{" "}
            {rowData.transactionId == "" ? "-" : rowData.transactionId}
          </td>
          <td className="col-lg-1 col-6 order-2">
            <span className="d-block d-lg-none">Amount</span>{" "}
            {/* <p
              className={`${
                rowData.topUp == 1 ? "plus-price " : "minus-price"
              } `}
            > */}
            {rowData.amount == "" ? "-" : rowData.amount}
            {/* </p> */}
          </td>
          <td className="col-lg-2 col-6 order-3">
            <span className="d-block d-lg-none">Time & Date</span>{" "}
            {rowData.date == "" ? "-" : rowData.date}
          </td>
          <td className="col-lg-2 col-6 order-4">
            <span className="d-block d-lg-none">Payment Method</span>
            {rowData.paymentMethod == "" ? "-" : rowData.paymentMethod}
          </td>
          <td className="col-lg-2 col-6 order-4">
            <span className="d-block d-lg-none">Category</span>
            {rowData.category == "" ? "-" : rowData.category}
          </td>
          <td className="d-lg-none d-block col-lg-2 col-12  align-text-media order-0">
            <div className="dropdown">
              <img
                // className="dropdown-toggle"
                type="button"
                id={`dropdownMenu${index}`}
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                src={toAbsoluteUrl("/media/images/action-icon.svg")}
                alt="action-icon"
              />
              <div
                className="dropdown-menu action-table-menu"
                aria-labelledby={`dropdownMenu${index}`}
              >
                {/* <button
                      onClick={() => {
                        if (rowData.statusOfInvitation == 0) {
                          resendInvite(rowData.userEmail);
                        } else {
                          handleOpen();
                        }
                      }}
                      className="dropdown-item"
                      type="button"
                    >
                      <img src={toAbsoluteUrl("/media/images/user-plus.svg")} />
                      <span>
                        {rowData.statusOfInvitation == 0
                          ? "Resend Invite"
                          : "Invite"}
                      </span>
                    </button> */}
              </div>
            </div>
          </td>
          <td className="d-lg-table-cell d-none col-lg-2 order-0">
            <div className="download-and-view-action">
              <div className="d-flex gap-8">
                <img
                  className="notDark"
                  src={toAbsoluteUrl("/media/images/download-icon.svg")}
                  alt="download-icon"
                />
                 <img
                 className="darkMode"
                  src={toAbsoluteUrl("/media/images/download-icon-dark.svg")}
                  alt="download-icon"
                />
                <p>Tax Invoice</p>
              </div>
              <div className="d-flex gap-8">
                <img
                  className="notDark"
                  src={toAbsoluteUrl("/media/images/eye (1).svg")}
                  alt="download-icon"
                />
                <img
                  className="darkMode"
                  src={toAbsoluteUrl("/media/images/eye (1)-dark.svg")}
                  alt="download-icon"
                />
                <p>View</p>
              </div>
            </div>
          </td>
        </tr>
      );
    });

    return studentsList;
  }
  function displayHead(params) {
    return (
      <tr className="d-none d-lg-table-row">
        <th className="col-1">Order ID </th>
        <th className="col-1">Transaction ID </th>
        <th className="col-2">Amount </th>
        <th className="col-2">Payment Method </th>
        <th className="col-2">Time & Date </th>
        <th className="col-2">Category </th>
        <th className="col-2">Actions</th>
      </tr>
    );
  }

  return (
    <div>
      {/* </div> */}
      {loading == 0 && false ? (
        <div className="display-flex-with-center justify-content-center mt-5">
          <div class="spinner-border" role="status">
            <span class="sr-only"></span>
          </div>
        </div>
      ) : (
        <>
          {users.length < 1 && firstLoadNoData && false ? (
            <div className="no-data-message mt-5">
              <p>You haven't made any transactions yet. </p>
            </div>
          ) : (
            <>
              <table id="table" class="dashboard-table mt-5">
                <thead>{displayHead()}</thead>
                <tbody>{displayBody()}</tbody>
              </table>
              {/* <Pagination
              limit={limit}
              setLimit={setLimit}
              setPage={setPage}
              
              {...data}
            /> */}
            </>
          )}
        </>
      )}
    </div>
  );
}
